<template>
  <div class="error-fallback" :class="{ 'fullscreen': fullscreen }">
    <div class="error-content">
      <div class="error-icon">⚠️</div>
      <h3 class="error-title">{{ title }}</h3>
      <p class="error-message">{{ message }}</p>
      <div class="error-actions">
        <button 
          v-if="showRetry" 
          @click="handleRetry" 
          class="retry-btn"
        >
          重试
        </button>
        <button 
          v-if="showHome" 
          @click="goHome" 
          class="home-btn"
        >
          返回首页
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { useRouter } from 'vue-router'

export default {
  name: 'ErrorFallback',
  props: {
    title: {
      type: String,
      default: '加载失败'
    },
    message: {
      type: String,
      default: '组件加载失败，请稍后重试'
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    showRetry: {
      type: Boolean,
      default: true
    },
    showHome: {
      type: Boolean,
      default: true
    }
  },
  emits: ['retry'],
  setup(props, { emit }) {
    const router = useRouter()
    
    const handleRetry = () => {
      emit('retry')
    }
    
    const goHome = () => {
      router.push('/')
    }
    
    return {
      handleRetry,
      goHome
    }
  }
}
</script>

<style scoped>
.error-fallback {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  min-height: 200px;
}

.error-fallback.fullscreen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #f5f5f5;
  z-index: 9999;
}

.error-content {
  text-align: center;
  max-width: 400px;
}

.error-icon {
  font-size: 48px;
  margin-bottom: 16px;
}

.error-title {
  color: #e74c3c;
  font-size: 20px;
  margin-bottom: 12px;
  font-weight: 600;
}

.error-message {
  color: #666;
  font-size: 14px;
  line-height: 1.5;
  margin-bottom: 24px;
}

.error-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
}

.retry-btn,
.home-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
  min-width: 80px;
}

.retry-btn {
  background-color: #007aff;
  color: white;
}

.retry-btn:hover {
  background-color: #0056b3;
}

.home-btn {
  background-color: #f8f9fa;
  color: #666;
  border: 1px solid #dee2e6;
}

.home-btn:hover {
  background-color: #e9ecef;
  color: #495057;
}

.retry-btn:active,
.home-btn:active {
  transform: translateY(1px);
}
</style>